import { jsx } from 'react/jsx-runtime';
import { useInternalDynamicContext } from '../../context/DynamicContext/useInternalDynamicContext.js';
import '@dynamic-labs/sdk-api';
import '../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/multi-wallet';
import '../../context/ViewContext/ViewContext.js';
import 'react';
import { ReactComponent as SvgLogout } from '../../shared/assets/logout.js';
import '../../utils/constants/colors.js';
import '../../shared/consts/index.js';
import { Button } from '../Button/Button.js';

const LogoutButton = ({ buttonClassName = '', isTextButton = false, }) => {
    const { handleLogOut } = useInternalDynamicContext();
    return (jsx(Button, Object.assign({ buttonClassName: buttonClassName, buttonVariant: 'tertiary', buttonRounded: 'small', buttonPadding: isTextButton ? 'none' : 'medium', onClick: handleLogOut, typographyProps: isTextButton
            ? { color: 'secondary', variant: 'button_tertiary' }
            : { color: 'primary', variant: 'button_secondary' }, dataTestId: 'logout-button', startSlot: isTextButton ? jsx(SvgLogout, {}) : undefined, expanded: !isTextButton, type: 'button' }, { children: "Log out" })));
};

export { LogoutButton };
